module.exports = __webpack_public_path__ + "static/media/breakfast.3c502b63.svg";